export default function(str)
{
    if(!str) {
        return str;
    }

    str = str.replace(/\r\n/g, "<br />");
    str = str.replace(/(\n|\r)/g, "<br />");
    return str;
}